import useMediaQuery from '@mui/material/useMediaQuery';

import { useTggTheme } from '../../contexts';
import { promoPalette } from '../../theme';
import { Icon } from '../Icon';

import { StyledCard } from './ProductHighlightPill.styled';
import { ProductHighlightPillProperties } from './ProductHighlightPill.types';

export function ProductHighlightPill({
    text,
    iconName,
    color,
    squeeze,
    className,
}: ProductHighlightPillProperties) {
    const { theme } = useTggTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));
    return (
        <StyledCard
            $squeeze={squeeze}
            $paletteColor={color}
            data-testid="pill"
            className={className}
        >
            {iconName && (
                <Icon
                    name={iconName}
                    color={promoPalette[color].text}
                    size={isDesktop ? 20 : 12}
                />
            )}
            {text}
        </StyledCard>
    );
}
